<template>
  <div class="col-md-12 col-sm-12 header-text p-0">
        <div class="d-flex">
          <b-col class="row ">
            <div class="col-md-5  description-box ">
                <div class="nino-mtavruli align-items-center d-flex text-center-div">{{$t('signatureaccept')}}</div>
            </div>
            <div class="col-md-7 background-color p-0 div-sm-top">
                <div class="align-items-center d-block p-1 esigne-text-size font-size2-sm">
                    <span class="text-color">{{$t('gigitallyaccepted')}}</span><br />
                    {{$t('date')}}: {{ serverDate.split(' ')[0] }}<br />
                    {{$t('time')}}: {{ serverDate.split(' ')[1] }}<br />
                </div>
              <img src="../../assets/img/esigne2.png" width="30" height="35" class="img-right mr-1 logo-margintop">
            </div>
          </b-col>
          <b-col class="row ">
            <div class="col-md-5  description-box ">
                <div class="align-items-center d-flex nino-mtavruli text-center-div">{{$t('signatureinsurer')}}</div>
            </div>
            <div class="col-md-7 p-1 background-color">
                <div class="div-height div-height-null div-sm-top">
                    <div class="text-desc border-bot font-size-sm">{{$t('JSCardi')}}</div>
                    {{$t('digitallyacceptedby')}}<br />  {{$t('JSCardi')}}<br />
                    {{$t('date')}}: {{ serverDate }}<br />
                </div>
             
              <img src="../../assets/img/esigne1.png" width="30" height="35" class="img-right mr-1">
            </div>
          </b-col>
        </div>
 </div>
</template>

<script>
export default {
  name: "Signature",
  data() {
    return {
      serverDate: ''
    }
  },
  mounted() {
    this.$http.get("/policy/getdate").then((r) => {
      this.serverDate = r.data
    }).catch((e) => {
      console.log(e)
    })
  }
}
</script>

<style scoped>

@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}

.img-right{
  float: right;
}
.background-color{
  border: 1px solid #EEEEEE;
}
.div-height{
  height: 95px;
}
.description-box {
  background-color: #007960;
  color: #fff;
}
.text-color{
  color: #007960;
}
.border-bot{
  border-bottom: dashed #007960;
  width: 100%;
}
.text-desc{
  font-size: 11px;
  font-weight: bold;
}
.esigne-text-size{
  font-size: 15px;
}
.text-center-div{
  height: 100px;
  text-align: center;
}

.header-text{
  font-size: 12px;
}


@media (max-width: 500px) {
  .right-border-sm{
    border-right: 1px solid #EEEEEE;
  }
  .description-box{
    height: 99px;
  }
  .div-height-null{
    height: unset;
  }
    .font-size-sm{
        font-size:9px;
    }
    .font-size2-sm {
        font-size: 13px;
        
    }
    .logo-margintop {
        margin-top: 1.5rem !important;
    }
    .div-sm-top {
        padding-top: 1rem !important;
    }
}
</style>